import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./utils/UseContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/v2">
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
    {/* <HashRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HashRouter> */}
  </React.StrictMode>
);
